// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { Row, Col, Form, Button, Modal } from "react-bootstrap";
// import Select from "react-select";
// import TextField from "@mui/material/TextField";
// import { FormControlLabel } from "@mui/material/FormControlLabel";
// import Checkbox from "@mui/material/Checkbox";
// import { Typography } from "antd";
// import { Toaster, toast } from "react-hot-toast";

// import axiosNew from "../../store/api/axiosNew";
// import hero from "../../Images/hero.jpg";
// import { Category, Visibility, VisibilityOff } from "@mui/icons-material";
// import { IoCall } from "react-icons/io5";
// import "./Signup.css";
// import axios from "axios";
// import { baseURLNew } from "../../store/api/axiosNew";
// import { signupAction_, setUser } from "../../store/action/common/authAction";
// import { connect } from "react-redux";
// import Tcmodel from "../../components/Tcmodel.jsx";
// import Header from "../../components/Header.jsx";
// import { ToastContainer } from "react-toastify";
// import { IconButton, InputAdornment } from "@mui/material";

// const { Title } = Typography;

// // const countryOptions = [
// //     { label: "India", value: "2" },
// // ]

// const Finalform = (props) => {
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();
//   const [errors, setErrors] = useState({});
//   const [name, setName] = useState("");
//   const [email, setEmail] = useState("");
//   const [number, setNumber] = useState("");
//   const [region, setRegion] = useState("");
//   const [myCountry, setCountry] = useState(null);
//   const [state, setState] = useState([]);
//   const [stateOptions, setStateOptions] = useState([]);
//   const [brand, setBrand] = useState("");
//   const [websiteURL, setWebsiteURL] = useState("");
//   const [agreeToTerms, setAgreeToTerms] = useState(false);
//   const [domainName, setDomainName] = useState(
//     sessionStorage.getItem("selectedService") || "",
//   );
//   const [showOtpModal, setShowOtpModal] = useState(false);
//   const [otp, setOtp] = useState(Array(6).fill(""));
//   const [location, setLocation] = useState("");
//   const [modalShow, setModalShow] = useState(false);
//   const [password, setPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const handleClose = () => setShowOtpModal(false);

//   const onSignupFinish = (values) => {
//     props.signupAction_(values);
//   };

//   // Handler to toggle state
//   const handleClickShowPassword = () => setShowPassword((prev) => !prev);
//   const handleClickShowConfirmPassword = () =>
//     setShowConfirmPassword((prev) => !prev);

//   // Handler to prevent default mouse event on icon click (prevents focus loss)
//   const handleMouseDownPassword = (event) => {
//     event.preventDefault();
//   };

//   // useEffect(() => {
//   //     const storedCountry = sessionStorage.getItem("selectedSubService");
//   //     if (storedCountry) {
//   //         const foundCountry = countryOptions.find((c) => c.label === storedCountry);
//   //         if (foundCountry) {
//   //             setCountry(foundCountry);
//   //             fetchStates(foundCountry.value);
//   //         }
//   //     }
//   // }, []);

//   // const fetchStates = async (countryId) => {
//   //     try {
//   //         const response = await fetch(`https://stageapilead.blaccdot.com/ldsstage/masters/location/country-based-province/${countryId}`);
//   //         const data = await response.json();
//   //         if (data?.data?.locationmaster) {
//   //             const formattedStates = data.data.locationmaster.map((s) => ({
//   //                 label: s.locationName,
//   //                 value: s.provinceId,
//   //             }))
//   //             setStateOptions(formattedStates);
//   //         }
//   //     }
//   //     catch (err) {
//   //         console.error("Error fetching states:", err);
//   //         setStateOptions([]);
//   //     }
//   // };

//   const validateForm = () => {
//     const errs = {};
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     const contactRegex = /^\d{10}$/;
//     // Add this regex inside validateForm
//     const passwordRegex =
//       /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

//     if (!password) {
//       errs.password = "Password is required";
//     } else if (!passwordRegex.test(password)) {
//       errs.password =
//         "Must be at least 8 characters long and include an uppercase, lowercase, number, and special character";
//     }

//     if (!confirmPassword) {
//       errs.confirmPassword = "Confirm Password is required";
//     } else if (password !== confirmPassword) {
//       errs.confirmPassword = "Passwords do not match";
//     }

//     if (!name.trim()) errs.fullName = "Full Name is required";
//     if (!email.trim()) errs.email = "Email is required";
//     else if (!emailRegex.test(email)) errs.email = "Invalid email format";
//     if (!number.trim()) errs.contactNo = "Contact Number is required";
//     else if (!contactRegex.test(number))
//       errs.contactNo = "Enter 10-digit number";
//     // if (!myCountry) errs.country = "Country is required";
//     // if (!state || state.length === 0) errs.state = "Select atleast one state";
//     if (!brand.trim()) errs.brand = "Brand Name is required";
//     if (!agreeToTerms)
//       errs.agreeToTerms = "You must agree to Terms & Conditions";
//     if (!location.trim()) errs.location = "Location is required";

//     setErrors(errs);
//     return Object.keys(errs).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;
//     setLoading(true);
//     ///
//     try {
//       // Step 1: Check if user exists / valid
//       const checkUserRes = await fetch(
//         "https://stageapilead.blaccdot.com/api/auth/check-user",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             email: email,
//             phone: number,
//           }),
//         },
//       );
//       const checkUserData = await checkUserRes.json();

//       if (!checkUserRes.ok || checkUserData?.success === false) {
//         toast.error(checkUserData?.message || "User validation failed");
//         return;
//       }
//       // Save form in sessionStorage or state (optional)
//       sessionStorage.setItem("name", name);
//       sessionStorage.setItem("email", email);
//       sessionStorage.setItem("number", number);
//       sessionStorage.setItem("country", myCountry?.label || "");
//       sessionStorage.setItem(
//         "state",
//         JSON.stringify(state?.map((item) => parseInt(item.value, 10)) || []),
//       );
//       sessionStorage.setItem("brand", brand);
//       sessionStorage.setItem("websiteURL", websiteURL);
//       sessionStorage.setItem("conuntyid", myCountry?.value || "");

//       ////
//       // try {
//       const otpRes = await fetch(
//         "https://euctostaging.com/lmsstage/api/send-otp",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ phone_number: number }),
//         },
//       );
//       const otpData = await otpRes.json();
//       if (otpRes.ok && otpData.success) {
//         toast.success("OTP sent");
//         setShowOtpModal(true);
//       } else {
//         toast.error("OTP sending failed");
//       }
//     } catch (err) {
//       toast.error("Error sending OTP");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleVerifyOtp = async () => {
//     const fullOtp = otp.join("");
//     if (fullOtp.length !== 6) {
//       toast.error("Enter 6-digit OTP");
//       return;
//     }
//     setLoading(true);
//     try {
//       const res = await fetch(
//         "https://euctostaging.com/lmsstage/api/verify-otp",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ phone_number: number, otp: fullOtp }),
//         },
//       );
//       const result = await res.json();
//       if (res.ok && result.success) {
//         toast.success("OTP Verified");
//         setShowOtpModal(false);
//         props.signupAction_({
//           name,
//           email,
//           password,
//           mobileNo: number,
//           // country: myCountry?.label || "",
//           // state: state.map((s) => s.value).join(","),
//           companyName: brand,
//           gmbProfileUrl: websiteURL,
//           location,
//         });
//       } else {
//         toast.error("Invalid OTP");
//       }
//     } catch (err) {
//       toast.error("OTP verification failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // const finalSubmit = async () => {
//   //     const payload = {
//   //         name,
//   //         email,
//   //         mobileNo: number,
//   //         country: myCountry?.label || "",
//   //         state: state.map((s) => s.value).join(","),
//   //         companyName: brand,
//   //         gmbProfileUrl: websiteURL,
//   //         location,
//   //     };
//   //     try {
//   //         // const res = await axiosNew.post("/auth/signup", payload);
//   //         const res = await axios.post(`${baseURLNew}auth/signup`, payload)
//   //         console.log("Signup raw response:", res);
//   //         console.log("Signup data:", res.data);
//   //         if (res.data?.success) {
//   //             localStorage.setItem("accessToken", res.data.tokens.accessToken);
//   //             localStorage.setItem("refreshToken", res.data.tokens.refreshToken);

//   //             localStorage.setItem("id", res.data.user.id);
//   //             localStorage.setItem("name", res.data.user.name);
//   //             localStorage.setItem("email", res.data.user.email);
//   //             localStorage.setItem("mobileNo", res.data.user.mobileNo);
//   //             localStorage.setItem("country", res.data.user.country);
//   //             localStorage.setItem("state", JSON.stringify(res.data.user.state));
//   //             localStorage.setItem("companyName", res.data.user.companyName);
//   //             localStorage.setItem("gmbProfileUrl", res.data.user.gmbProfileUrl);
//   //             localStorage.setItem("role", res.data.user.role);
//   //             localStorage.setItem("subscriptionSignup", res.data.user.subscriptionSignup);

//   //             // props.setUser_({
//   //             //     email: res.data.user.email,
//   //             //     role: res.data.user.role,
//   //             //     name: res.data.user.name,
//   //             // });

//   //             if (res.data.user.role?.toLowerCase() === "business") {
//   //                 navigate("/user-dashboard");
//   //             }
//   //             else if (res.data.user.role?.toLowerCase() === "admin") {
//   //                 navigate('/admin');
//   //             }
//   //         }
//   //         else {
//   //             toast.error("Submission failed");
//   //         }
//   //     }
//   //     catch (err) {
//   //         toast.error("Form submission error");
//   //         console.error(err);
//   //     }
//   // };
//   // useEffect(() => {
//   //     console.log(props?.signupResponse, "PROPS RESPONSE")
//   //     if (props.signupResponse && props.signupResponse.tokens?.accessToken) {
//   //         Promise.resolve().then(() => {
//   //             localStorage.setItem("accessToken", props.signupResponse.tokens.accessToken);
//   //             localStorage.setItem("refreshToken", props.signupResponse.tokens.refreshToken);
//   //             localStorage.setItem("email", props.signupResponse.user.email);
//   //             localStorage.setItem("role", props.signupResponse.user.role);
//   //             localStorage.setItem("name", props.signupResponse.user.name);
//   //             localStorage.setItem("userId", props.signupResponse.user.userId);
//   //             localStorage.setItem("id", props.signupResponse.user.id);
//   //             localStorage.setItem("phone", props.signupResponse.user.mobileNo);
//   //             localStorage.setItem("companyName", props.signupResponse.user.companyName);
//   //             localStorage.setItem("country", props.signupResponse.user.country);
//   //             localStorage.setItem("domain", props.signupResponse.user.categoryName);
//   //             localStorage.setItem("domainid", props.signupResponse.user.category);

//   //             props.setUser_({
//   //                 email: localStorage.getItem("email"),
//   //                 role: localStorage.getItem("role"),
//   //                 name: localStorage.getItem("name"),
//   //             });
//   //         })
//   //             .then(() => {
//   //                 if (props.signupResponse.user.role?.toLowerCase() === "business") {
//   //                     navigate("/user-dashboard");
//   //                 } else if (props.signupResponse.user.role?.toLowerCase() === "admin") {
//   //                     navigate("/admin");
//   //                 }
//   //             })
//   //     }
//   // }, [props.signupResponse])
//   useEffect(() => {
//     if (props.signupResponse && props.signupResponse.tokens?.accessToken) {
//       navigate("/login", {
//         state: {
//           signupEmail: props.signupResponse.user.email,
//           showPasswordHint: true,
//         },
//       });
//     }
//   }, [props.signupResponse]);
//   useEffect(() => {
//     if (props.signupResponse && props.signupResponse.success) {
//       toast.success("Signup successful!");
//     }
//   }, [props.signupResponse]);

//   useEffect(() => {
//     if (props.signupError && props.signupError.message) {
//       console.log("Signup error triggered:", props.signupError);

//       if (props.signupError.message.includes("E11000")) {
//         toast.error("Email or phone already exists", {
//           duration: 19000,
//         });
//       } else {
//         toast.error(props.signupError.message, {
//           duration: 19000,
//         });
//       }
//     }
//   }, [props.signupError]);

//   const handleChangeMain = (e, index) => {
//     const value = e.target.value.replace(/[^0-9]/g, "");
//     if (value.length > 1) return;

//     const newOtp = [...otp];
//     newOtp[index] = value;
//     setOtp(newOtp);

//     if (value && index < 5) {
//       const nextInput = document.getElementById(`otp-${index + 1}`);
//       nextInput?.focus();
//     }
//   };

//   const handleKeyDown = (e, index) => {
//     if (e.key === "Backspace") {
//       if (otp[index]) {
//         const newOtp = [...otp];
//         newOtp[index] = "";
//         setOtp(newOtp);
//       } else if (index > 0) {
//         const newOtp = [...otp];
//         newOtp[index - 1] = "";
//         setOtp(newOtp);
//         const prevInput = document.getElementById(`otp-${index - 1}`);
//         prevInput?.focus();
//       }
//       e.preventDefault();
//     }
//   };
//   const handleCheckboxChange = (e) => {
//     setAgreeToTerms(e.target.checked);
//     const newErrors = { ...errors };
//     delete newErrors.agreeToTerms;
//     setErrors(newErrors);
//   };

//  return (
//   <>
//     <Header />
//     <Toaster autoClose={3000} />

//     <div
//       style={{
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         minHeight: "100vh",
//         backgroundColor: "#E6EDF3",
//       }}
//     >
//       <div style={{ backgroundColor: "#E6EDF3", width: "100vw" }}>
//         <div className="container py-3">
//           <div className="formBoxsh">
//             <Row>
//               <Col md={5} className="FormImages">
//                 <img src={hero} alt="Hero" className="hero-image" />
//               </Col>
//               <Col md={7}>
//                 <div className="mainTopic">
//                   <h5>One step to get quality leads</h5>
//                 </div>
//                 <Form onSubmit={handleSubmit} className="signup-form">
//                   <Row>
//                     <Col xs={12} md={4} className="form-col">
//                       <TextField
//                         label="Full Name"
//                         value={name}
//                         fullWidth
//                         onChange={(e) => setName(e.target.value)}
//                         error={!!errors.fullName}
//                         helperText={errors.fullName}
//                       />
//                     </Col>
//                     <Col xs={12} md={4} className="form-col">
//                       <TextField
//                         label="Email"
//                         type="email"
//                         value={email}
//                         fullWidth
//                         onChange={(e) => setEmail(e.target.value)}
//                         error={!!errors.email}
//                         helperText={errors.email}
//                       />
//                     </Col>
//                     <Col xs={12} md={4} className="form-col">
//                       <TextField
//                         label="Contact Number"
//                         value={number}
//                         fullWidth
//                         disabled={showOtpModal} // Lock number field while verifying
//                         onChange={(e) => setNumber(e.target.value)}
//                         error={!!errors.contactNo}
//                         helperText={errors.contactNo}
//                       />
//                     </Col>
//                   </Row>

//                   {/* INLINE OTP VERIFICATION SECTION */}
//                   {showOtpModal && (
//                     <Row className="mt-3">
//                       <Col xs={12}>
//                         <div
//                           style={{
//                             padding: "16px",
//                             backgroundColor: "#f8f9fa",
//                             borderRadius: "8px",
//                             border: "1px dashed #1976d2",
//                           }}
//                         >
//                           <div
//                             style={{
//                               display: "flex",
//                               justifyContent: "space-between",
//                               alignItems: "center",
//                               marginBottom: "10px",
//                             }}
//                           >
//                             <span style={{ fontSize: "14px", color: "#333" }}>
//                               Enter verification code sent to{" "}
//                               <strong>+91 {number}</strong>
//                             </span>
//                             <span
//                               onClick={handleClose}
//                               style={{
//                                 textDecoration: "underline",
//                                 color: "#1976d2",
//                                 cursor: "pointer",
//                                 fontSize: "13px",
//                                 fontWeight: "500",
//                               }}
//                             >
//                               Change Number
//                             </span>
//                           </div>

//                           <div
//                             className="otp-inputs"
//                             style={{
//                               display: "flex",
//                               gap: "8px",
//                               marginBottom: "12px",
//                             }}
//                           >
//                             {otp.map((digit, i) => (
//                               <input
//                                 key={i}
//                                 id={`otp-${i}`}
//                                 type="text"
//                                 maxLength={1}
//                                 value={digit}
//                                 onChange={(e) => handleChangeMain(e, i)}
//                                 onKeyDown={(e) => handleKeyDown(e, i)}
//                                 className="otp-box"
//                               />
//                             ))}
//                           </div>

//                           <Button
//                             variant="contained"
//                             size="small"
//                             onClick={handleVerifyOtp}
//                             style={{ textTransform: "none" }}
//                           >
//                             Verify & Confirm
//                           </Button>
//                         </div>
//                       </Col>
//                     </Row>
//                   )}

//                   <Row className="mt-4">
//                     <Col xs={12} md={4} className="form-col">
//                       <TextField
//                         label="Brand Name"
//                         value={brand}
//                         fullWidth
//                         onChange={(e) => setBrand(e.target.value)}
//                         error={!!errors.brand}
//                         helperText={errors.brand}
//                       />
//                     </Col>
//                     <Col xs={12} md={4} className="form-col">
//                       <TextField
//                         label="Website URL"
//                         value={websiteURL}
//                         fullWidth
//                         onChange={(e) => setWebsiteURL(e.target.value)}
//                         error={!!errors.websiteURL}
//                         helperText={errors.websiteURL}
//                       />
//                     </Col>
//                     <Col xs={12} md={4} className="form-col">
//                       <TextField
//                         label="Location"
//                         value={location}
//                         fullWidth
//                         onChange={(e) => setLocation(e.target.value)}
//                         error={!!errors.location}
//                         helperText={errors.location}
//                       />
//                     </Col>
//                   </Row>

//                   <Row className="mt-3">
//                     <Col xs={12} md={6} className="form-col mb-3">
//                       <TextField
//                         label="Password"
//                         type={showPassword ? "text" : "password"}
//                         value={password}
//                         fullWidth
//                         onChange={(e) => setPassword(e.target.value)}
//                         error={!!errors.password}
//                         helperText={errors.password}
//                         InputProps={{
//                           endAdornment: (
//                             <InputAdornment position="end">
//                               <IconButton
//                                 aria-label="toggle password visibility"
//                                 onClick={handleClickShowPassword}
//                                 onMouseDown={handleMouseDownPassword}
//                                 edge="end"
//                               >
//                                 {showPassword ? (
//                                   <VisibilityOff />
//                                 ) : (
//                                   <Visibility />
//                                 )}
//                               </IconButton>
//                             </InputAdornment>
//                           ),
//                         }}
//                       />
//                     </Col>
//                     <Col xs={12} md={6} className="form-col mb-3">
//                       <TextField
//                         label="Confirm Password"
//                         type={showConfirmPassword ? "text" : "password"}
//                         value={confirmPassword}
//                         fullWidth
//                         onChange={(e) => setConfirmPassword(e.target.value)}
//                         error={!!errors.confirmPassword}
//                         helperText={errors.confirmPassword}
//                         InputProps={{
//                           endAdornment: (
//                             <InputAdornment position="end">
//                               <IconButton
//                                 aria-label="toggle confirm password visibility"
//                                 onClick={handleClickShowConfirmPassword}
//                                 onMouseDown={handleMouseDownPassword}
//                                 edge="end"
//                               >
//                                 {showConfirmPassword ? (
//                                   <VisibilityOff />
//                                 ) : (
//                                   <Visibility />
//                                 )}
//                               </IconButton>
//                             </InputAdornment>
//                           ),
//                         }}
//                       />
//                     </Col>
//                   </Row>

//                   <div className="d-flex flex-column mt-3">
//                     <Form.Check
//                       type="checkbox"
//                       label={
//                         <span style={{ fontSize: "14px", color: "#555" }}>
//                           I agree to the{" "}
//                           <span
//                             onClick={() => setModalShow(true)}
//                             style={{
//                               color: "#007bff",
//                               textDecoration: "none",
//                               fontWeight: "500",
//                               cursor: "pointer",
//                             }}
//                           >
//                             Terms & Conditions
//                           </span>
//                         </span>
//                       }
//                       checked={agreeToTerms}
//                       onChange={handleCheckboxChange}
//                       isInvalid={!!errors.agreeToTerms}
//                     />
//                     {errors.agreeToTerms && (
//                       <span
//                         style={{
//                           color: "red",
//                           marginLeft: "6px",
//                           fontWeight: "400",
//                           fontSize: "13px",
//                         }}
//                       >
//                         {errors.agreeToTerms}
//                       </span>
//                     )}
//                   </div>

//                   <Tcmodel
//                     show={modalShow}
//                     onHide={() => setModalShow(false)}
//                   />

//                   <div
//                     style={{
//                       display: "flex",
//                       justifyContent: "center",
//                       marginTop: "20px",
//                     }}
//                   >
//                     <Button type="submit" disabled={loading}>
//                       {loading ? "Signing in..." : "Sign Up"}
//                     </Button>
//                   </div>
//                 </Form>
//               </Col>
//             </Row>
//           </div>
//         </div>
//       </div>
//     </div>
//   </>
// );
// };

// const mapStateToProps = (state) => ({
//   signupResponse: state.signup.response,
//   signupLoading: state.signup.loading,
//   signupError: state.signup.error,
// });

// const mapDispatchToProps = (dispatch) => ({
//   signupAction_: (data) => {
//     dispatch(signupAction_(data));
//   },
//   setUser_: (data) => {
//     dispatch(setUser(data));
//   },
// });

// export default connect(mapStateToProps, mapDispatchToProps)(Finalform);

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Form, Button } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import { Typography } from "antd";
import { Toaster, toast } from "react-hot-toast";

import hero from "../../Images/hero.jpg";
import { Visibility, VisibilityOff, CheckCircle } from "@mui/icons-material";
import "./Signup.css";
import { signupAction_, setUser } from "../../store/action/common/authAction";
import { connect } from "react-redux";
import Tcmodel from "../../components/Tcmodel.jsx";
import Header from "../../components/Header.jsx";
import { IconButton, InputAdornment, Button as MuiButton } from "@mui/material";

const { Title } = Typography;

const Finalform = (props) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState("");
  const [brand, setBrand] = useState("");
  const [websiteURL, setWebsiteURL] = useState("");
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const [location, setLocation] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // --- OTP & VERIFICATION STATES ---
  const [showOtpSection, setShowOtpSection] = useState(false);
  const [isPhoneVerified, setIsPhoneVerified] = useState(false);
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [timer, setTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);

  // Timer Effect for OTP Resend Countdown
  useEffect(() => {
    let interval;
    if (showOtpSection && timer > 0 && !isPhoneVerified) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      setCanResend(true);
    }
    return () => clearInterval(interval);
  }, [showOtpSection, timer, isPhoneVerified]);

  // Direct trigger for Contact Number field "Verify" button
  const handleSendOtp = async () => {
    const contactRegex = /^\d{10}$/;
    if (!number.trim() || !contactRegex.test(number)) {
      setErrors((prev) => ({
        ...prev,
        contactNo: "Enter valid 10-digit number",
      }));
      return;
    }

    setLoading(true);
    try {
      // Step 1: Pre-check user availability
      const checkUserRes = await fetch(
        "https://stageapilead.blaccdot.com/api/auth/check-user",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, phone: number }),
        },
      );
      const checkUserData = await checkUserRes.json();

      if (!checkUserRes.ok || checkUserData?.success === false) {
        toast.error(checkUserData?.message || "User validation failed");
        return;
      }

      // Step 2: Send OTP
      const otpRes = await fetch(
        "https://euctostaging.com/lmsstage/api/send-otp",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ phone_number: number }),
        },
      );
      const otpData = await otpRes.json();

      if (otpRes.ok && otpData.success) {
        toast.success("OTP sent to your number");
        setShowOtpSection(true);
        setTimer(30);
        setCanResend(false);
        setErrors((prev) => ({ ...prev, contactNo: "" }));
      } else {
        toast.error("Failed to send OTP");
      }
    } catch (err) {
      toast.error("Error sending OTP");
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    setLoading(true);
    try {
      const otpRes = await fetch(
        "https://euctostaging.com/lmsstage/api/send-otp",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ phone_number: number }),
        },
      );
      const otpData = await otpRes.json();
      if (otpRes.ok && otpData.success) {
        toast.success("OTP resent successfully");
        setTimer(30);
        setCanResend(false);
        setOtp(Array(6).fill(""));
      } else {
        toast.error("Failed to resend OTP");
      }
    } catch (err) {
      toast.error("Error resending OTP");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    const fullOtp = otp.join("");
    if (fullOtp.length !== 6) {
      toast.error("Enter 6-digit OTP");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(
        "https://euctostaging.com/lmsstage/api/verify-otp",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ phone_number: number, otp: fullOtp }),
        },
      );
      const result = await res.json();
      if (res.ok && result.success) {
        toast.success("Mobile number verified successfully!");
        setIsPhoneVerified(true);
        setShowOtpSection(false); // Hide OTP card upon success
      } else {
        toast.error("Invalid OTP. Please try again.");
      }
    } catch (err) {
      toast.error("OTP verification failed");
    } finally {
      setLoading(false);
    }
  };

  const validateForm = () => {
    const errs = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const contactRegex = /^\d{10}$/;
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

    if (!password) {
      errs.password = "Password is required";
    } else if (!passwordRegex.test(password)) {
      errs.password =
        "Must be at least 8 characters long and include an uppercase, lowercase, number, and special character";
    }

    if (!confirmPassword) {
      errs.confirmPassword = "Confirm Password is required";
    } else if (password !== confirmPassword) {
      errs.confirmPassword = "Passwords do not match";
    }

    if (!name.trim()) errs.fullName = "Full Name is required";
    if (!email.trim()) errs.email = "Email is required";
    else if (!emailRegex.test(email)) errs.email = "Invalid email format";
    if (!number.trim()) errs.contactNo = "Contact Number is required";
    else if (!contactRegex.test(number))
      errs.contactNo = "Enter 10-digit number";
    if (!brand.trim()) errs.brand = "Brand Name is required";
    if (!agreeToTerms)
      errs.agreeToTerms = "You must agree to Terms & Conditions";
    if (!location.trim()) errs.location = "Location is required";

    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    if (!isPhoneVerified) {
      toast.error("Please verify your mobile number before submitting!");
      return;
    }

    props.signupAction_({
      name,
      email,
      password,
      mobileNo: number,
      companyName: brand,
      gmbProfileUrl: websiteURL,
      location,
    });
  };

  const handleClickShowPassword = () => setShowPassword((prev) => !prev);
  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword((prev) => !prev);

  const handleMouseDownPassword = (event) => event.preventDefault();

  useEffect(() => {
    if (props.signupResponse && props.signupResponse.tokens?.accessToken) {
      navigate("/login", {
        state: {
          signupEmail: props.signupResponse.user.email,
          showPasswordHint: true,
        },
      });
    }
  }, [props.signupResponse, navigate]);

  useEffect(() => {
    if (props.signupResponse && props.signupResponse.success) {
      toast.success("Signup successful!");
    }
  }, [props.signupResponse]);

  useEffect(() => {
    if (props.signupError && props.signupError.message) {
      toast.error(
        props.signupError.message.includes("E11000")
          ? "Email or phone already exists"
          : props.signupError.message,
        { duration: 19000 },
      );
    }
  }, [props.signupError]);

  const handleChangeMain = (e, index) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    if (value.length > 1) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      nextInput?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index]) {
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        const newOtp = [...otp];
        newOtp[index - 1] = "";
        setOtp(newOtp);
        const prevInput = document.getElementById(`otp-${index - 1}`);
        prevInput?.focus();
      }
      e.preventDefault();
    }
  };

  const handleCheckboxChange = (e) => {
    setAgreeToTerms(e.target.checked);
    const newErrors = { ...errors };
    delete newErrors.agreeToTerms;
    setErrors(newErrors);
  };

  return (
    <>
      <Header />
      <Toaster autoClose={3000} />

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          backgroundColor: "#E6EDF3",
        }}
      >
        <div style={{ backgroundColor: "#E6EDF3", width: "100vw" }}>
          <div className="container py-3">
            <div className="formBoxsh">
              <Row>
                <Col md={4} className="FormImages">
                  <img src={hero} alt="Hero" className="hero-image" />
                </Col>
                <Col md={8}>
                  <div className="mainTopic">
                    <h5>One step to get quality leads</h5>
                  </div>
                  <Form onSubmit={handleSubmit} className="signup-form">
                    <Row>
                      <Col xs={12} md={4} className="form-col">
                        <TextField
                          label="Full Name"
                          value={name}
                          fullWidth
                          onChange={(e) => setName(e.target.value)}
                          error={!!errors.fullName}
                          helperText={errors.fullName}
                        />
                      </Col>
                      <Col xs={12} md={4} className="form-col">
                        <TextField
                          label="Email"
                          type="email"
                          value={email}
                          fullWidth
                          onChange={(e) => setEmail(e.target.value)}
                          error={!!errors.email}
                          helperText={errors.email}
                        />
                      </Col>

                      {/* CONTACT NUMBER FIELD WITH OVERLAP FIX */}
                      <Col xs={12} md={4} className="form-col">
                        <TextField
                          label="Contact Number"
                          value={number}
                          fullWidth
                          disabled={showOtpSection || isPhoneVerified}
                          onChange={(e) => setNumber(e.target.value)}
                          error={!!errors.contactNo}
                          helperText={errors.contactNo}
                          slotProps={{
                            htmlInput: {
                              style: { paddingRight: "8px" },
                            },
                          }}
                          InputProps={{
                            style: { paddingRight: "6px" },
                            endAdornment: (
                              <InputAdornment position="end">
                                {isPhoneVerified ? (
                                  <span
                                    style={{
                                      color: "#2e7d32",
                                      display: "flex",
                                      alignItems: "center",
                                      fontSize: "12px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    <CheckCircle
                                      fontSize="small"
                                      style={{ marginRight: "2px" }}
                                    />{" "}
                                    Verified
                                  </span>
                                ) : (
                                  !showOtpSection && (
                                    <MuiButton
                                      size="small"
                                      variant="contained"
                                      disableElevation
                                      onClick={handleSendOtp}
                                      disabled={loading}
                                      style={{
                                        textTransform: "none",
                                        fontSize: "11px",
                                        padding: "3px 8px",
                                        minWidth: "auto",
                                      }}
                                    >
                                      Verify
                                    </MuiButton>
                                  )
                                )}
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Col>
                    </Row>

                    {/* EXPANDABLE INLINE OTP CARD BELOW CONTACT FIELD */}
                    {showOtpSection && !isPhoneVerified && (
                      <Row className="mt-2">
                        <Col xs={12}>
                          <div
                            style={{
                              padding: "16px",
                              backgroundColor: "#f8f9fa",
                              borderRadius: "8px",
                              border: "1px dashed #1976d2",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "10px",
                              }}
                            >
                              <span style={{ fontSize: "13px", color: "#333" }}>
                                Enter 6-digit code sent to{" "}
                                <strong>+91 {number}</strong>
                              </span>
                              <span
                                onClick={() => {
                                  setShowOtpSection(false);
                                  setOtp(Array(6).fill(""));
                                }}
                                style={{
                                  textDecoration: "underline",
                                  color: "#1976d2",
                                  cursor: "pointer",
                                  fontSize: "12px",
                                  fontWeight: "500",
                                }}
                              >
                                Change Number
                              </span>
                            </div>

                            <div
                              className="otp-inputs"
                              style={{
                                display: "flex",
                                gap: "8px",
                                marginBottom: "18px",
                              }}
                            >
                              {otp.map((digit, i) => (
                                <input
                                  key={i}
                                  id={`otp-${i}`}
                                  type="tel" // Changes input type to telephone to enforce number keypad
                                  inputMode="numeric" // Forces mobile browsers to show the numeric keypad
                                  pattern="[0-9]*" // Enforces numeric key layout on iOS devices
                                  autoComplete="one-time-code"
                                  maxLength={1}
                                  value={digit}
                                  onChange={(e) => handleChangeMain(e, i)}
                                  onKeyDown={(e) => handleKeyDown(e, i)}
                                  className="otp-box"
                                />
                              ))}
                            </div>

                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: "12px",
                              }}
                            >
                              <div style={{ fontSize: "12px", color: "#666" }}>
                                {canResend ? (
                                  <span
                                    onClick={handleResendOtp}
                                    style={{
                                      color: "#1976d2",
                                      cursor: "pointer",
                                      fontWeight: "600",
                                      textDecoration: "underline",
                                    }}
                                  >
                                    Resend OTP
                                  </span>
                                ) : (
                                  <span>
                                    Resend OTP in{" "}
                                    <strong style={{ color: "#d32f2f" }}>
                                      {timer}s
                                    </strong>
                                  </span>
                                )}
                              </div>
                              <Button
                                type="button"
                                variant="primary"
                                size="sm"
                                onClick={handleVerifyOtp}
                                disabled={loading}
                                style={{ textTransform: "none" }}
                              >
                                Verify OTP
                              </Button>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    )}

                    <Row className="mt-4">
                      <Col xs={12} md={4} className="form-col">
                        <TextField
                          label="Brand Name"
                          value={brand}
                          fullWidth
                          onChange={(e) => setBrand(e.target.value)}
                          error={!!errors.brand}
                          helperText={errors.brand}
                        />
                      </Col>
                      <Col xs={12} md={4} className="form-col">
                        <TextField
                          label="Website URL"
                          value={websiteURL}
                          fullWidth
                          onChange={(e) => setWebsiteURL(e.target.value)}
                          error={!!errors.websiteURL}
                          helperText={errors.websiteURL}
                        />
                      </Col>
                      <Col xs={12} md={4} className="form-col">
                        <TextField
                          label="Location"
                          value={location}
                          fullWidth
                          onChange={(e) => setLocation(e.target.value)}
                          error={!!errors.location}
                          helperText={errors.location}
                        />
                      </Col>
                    </Row>

                    <Row className="mt-3">
                      <Col xs={12} md={6} className="form-col mb-3">
                        <TextField
                          label="Password"
                          type={showPassword ? "text" : "password"}
                          value={password}
                          fullWidth
                          onChange={(e) => setPassword(e.target.value)}
                          error={!!errors.password}
                          helperText={errors.password}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                >
                                  {showPassword ? (
                                    <VisibilityOff />
                                  ) : (
                                    <Visibility />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Col>
                      <Col xs={12} md={6} className="form-col mb-3">
                        <TextField
                          label="Confirm Password"
                          type={showConfirmPassword ? "text" : "password"}
                          value={confirmPassword}
                          fullWidth
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          error={!!errors.confirmPassword}
                          helperText={errors.confirmPassword}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle confirm password visibility"
                                  onClick={handleClickShowConfirmPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                >
                                  {showConfirmPassword ? (
                                    <VisibilityOff />
                                  ) : (
                                    <Visibility />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Col>
                    </Row>

                    <div className="d-flex flex-column mt-3">
                      <Form.Check
                        type="checkbox"
                        label={
                          <span style={{ fontSize: "14px", color: "#555" }}>
                            I agree to the{" "}
                            <span
                              onClick={() => setModalShow(true)}
                              style={{
                                color: "#007bff",
                                textDecoration: "none",
                                fontWeight: "500",
                                cursor: "pointer",
                              }}
                            >
                              Terms & Conditions
                            </span>
                          </span>
                        }
                        checked={agreeToTerms}
                        onChange={handleCheckboxChange}
                        isInvalid={!!errors.agreeToTerms}
                      />
                      {errors.agreeToTerms && (
                        <span
                          style={{
                            color: "red",
                            marginLeft: "6px",
                            fontWeight: "400",
                            fontSize: "13px",
                          }}
                        >
                          {errors.agreeToTerms}
                        </span>
                      )}
                    </div>

                    <Tcmodel
                      show={modalShow}
                      onHide={() => setModalShow(false)}
                    />

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "20px",
                      }}
                    >
                      <Button type="submit" disabled={loading}>
                        {loading ? "Processing..." : "Sign Up"}
                      </Button>
                    </div>
                  </Form>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  signupResponse: state.signup.response,
  signupLoading: state.signup.loading,
  signupError: state.signup.error,
});

const mapDispatchToProps = (dispatch) => ({
  signupAction_: (data) => {
    dispatch(signupAction_(data));
  },
  setUser_: (data) => {
    dispatch(setUser(data));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Finalform);
